import { useTranslate } from "@lobby/ocb-intl";
import type { PropsWithChildren, ReactNode } from "react";
import { Skeleton, range } from "../../shared";
import { GameCard } from "../GameCard";

export function GameListHeader({
  label,
  CategoryIcon,
  children,
}: PropsWithChildren<{
  label: string;
  CategoryIcon: ReactNode;
}>) {
  return (
    <div
      style={{
        color: "var(--game-list-header-color)",
      }}
      className="flex min-h-10 justify-between"
    >
      <div className="flex items-center gap-1.5 self-start mobile-only:pt-2.5 text-20">
        {CategoryIcon}
        <span className="font-medium text-15 uppercase lg:text-22">{label}</span>
      </div>
      {children}
    </div>
  );
}

export function GameListEmpty() {
  const { $t } = useTranslate();

  return (
    <div className="text-14 lg:text-22">{$t({ defaultMessage: "No games in this category" })}</div>
  );
}

export function GameListSkeleton() {
  return (
    <section>
      <div className="flex justify-between">
        <Skeleton className="h-7.5 w-60" />

        <div className="flex">
          <Skeleton className="me-[0.3125rem] size-10" />
          <Skeleton className="size-10" />
          <Skeleton className="ms-2.5 h-10 w-[9.6875rem]" />
        </div>
      </div>

      <div className="mt-5">
        <div className="flex gap-2.5 overflow-x-auto *:shrink-0 *:basis-36">
          {range(11)((idx) => (
            <GameCard.Skeleton key={idx} />
          ))}
        </div>
      </div>
    </section>
  );
}
